// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/OpengraphAuditResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/OpengraphAuditResult.tsx");
  import.meta.hot.lastModified = "1732036225890.4243";
}
// REMIX HMR END

import ContentWrapper from "~/components/ContentWrapper";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { Google } from "./MetatagsCards/Google";
import { Linkedin } from "./MetatagsCards/LinkedIn";
import { Twitter } from "./MetatagsCards/Twitter";
import { Facebook } from "./MetatagsCards/Facebook";
import { Slack } from "./MetatagsCards/Slack";
import { Metadata } from "./MetatagsCards/Metadata";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";
import Heading from "~/components/Heading";
const opengraphItems = [{
  title: "Google",
  Card: Google,
  accessor: "google"
}, {
  title: "X/Twitter",
  Card: Twitter,
  accessor: "twitter"
}, {
  title: "Linkedin",
  Card: Linkedin,
  accessor: "linkedin"
}, {
  title: "Facebook",
  Card: Facebook,
  accessor: "facebook"
}, {
  title: "Slack",
  Card: Slack,
  accessor: "slack"
}];
export default function OpengraphAuditResult({
  cards
}) {
  return <ContentWrapper spacing="primary" Item="section" className="w-full bg-white flex-col items-center [&_.lh-topbar]:z-0">
      <Heading tag="h2" className="text-center">
        Meta Tags Check: Report Summary
      </Heading>
      <Tabs className="w-full !max-w-none" defaultValue={opengraphItems[0].title}>
        <TabsList>
          {opengraphItems.map(({
          title
        }) => <TabsTrigger key={title} value={title}>
              {title}
            </TabsTrigger>)}
        </TabsList>
        {opengraphItems.map(({
        title,
        Card,
        accessor
      }) => {
        const metaTags = cards[accessor].values;
        return <TabsContent key={title} className="children:pt-0" value={title}>
              <Accordion className="w-full mb-8" type="multiple">
                <AccordionItem value="Metadata">
                  <AccordionTrigger>View Metadata</AccordionTrigger>
                  <AccordionContent>
                    <Metadata {...metaTags} />
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
              <Card key={title} {...metaTags} />
            </TabsContent>;
      })}
      </Tabs>
    </ContentWrapper>;
}
_c = OpengraphAuditResult;
var _c;
$RefreshReg$(_c, "OpengraphAuditResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;